import React from 'react';

import { useGetDashboardRecordsActivityQuery } from 'src/api';
import { POSITION_EMPLOYMENT_STATUS_LABEL } from 'src/constants/position';

import { useDashboardCVAdminData } from './useDashboardCVAdminData';

export const useDashboardRecordsActivity = () => {
  const { employers, peos } = useDashboardCVAdminData();

  const { data, loading } = useGetDashboardRecordsActivityQuery({
    variables: {
      employerIds: employers?.map(item => item.id),
      peoIds: peos?.map(item => item.id),
    },
  });

  const { dataset, counts } = React.useMemo(() => {
    if (!data) return { dataset: [], counts: { total: 0, active: 0, inactive: 0 } };

    const activeDataset = [
      {
        value: data.getDashboardRecordsActivity.active.Active,
        name: POSITION_EMPLOYMENT_STATUS_LABEL.Active,
      },
      {
        value: data.getDashboardRecordsActivity.active.FMLA,
        name: POSITION_EMPLOYMENT_STATUS_LABEL.FMLA,
      },
      {
        value: data.getDashboardRecordsActivity.active.IFMLA,
        name: POSITION_EMPLOYMENT_STATUS_LABEL.IFMLA,
      },
      {
        value: data.getDashboardRecordsActivity.active.On_Leave,
        name: POSITION_EMPLOYMENT_STATUS_LABEL.On_Leave,
      },
      {
        value: data.getDashboardRecordsActivity.active.Intern,
        name: POSITION_EMPLOYMENT_STATUS_LABEL.Intern,
      },
    ].toSorted((a, b) => b.value - a.value);

    const inactiveDataset = [
      {
        value: data.getDashboardRecordsActivity.inactive.Deceased,
        name: POSITION_EMPLOYMENT_STATUS_LABEL.Deceased,
      },
      {
        value: data.getDashboardRecordsActivity.inactive.Terminated,
        name: POSITION_EMPLOYMENT_STATUS_LABEL.Terminated,
      },
      {
        value: data.getDashboardRecordsActivity.inactive.Severed_With_Pay,
        name: POSITION_EMPLOYMENT_STATUS_LABEL.Severed_With_Pay,
      },
      {
        value: data.getDashboardRecordsActivity.inactive.Separated,
        name: POSITION_EMPLOYMENT_STATUS_LABEL.Separated,
      },
      {
        value: data.getDashboardRecordsActivity.inactive.Retired,
        name: POSITION_EMPLOYMENT_STATUS_LABEL.Retired,
      },
      {
        value: data.getDashboardRecordsActivity.inactive.Temporarily_Inactive,
        name: POSITION_EMPLOYMENT_STATUS_LABEL.Temporarily_Inactive,
      },
      {
        value: data.getDashboardRecordsActivity.inactive.Inactive,
        name: POSITION_EMPLOYMENT_STATUS_LABEL.Inactive,
      },
      {
        value: data.getDashboardRecordsActivity.inactive.Unknown,
        name: POSITION_EMPLOYMENT_STATUS_LABEL.Unknown,
      },
    ].toSorted((a, b) => a.value - b.value);

    const activeCount = Object.values(activeDataset).reduce((acc, item) => acc + item.value, 0);
    const inactiveCount = Object.values(inactiveDataset).reduce((acc, item) => acc + item.value, 0);

    return {
      dataset: [...activeDataset, ...inactiveDataset],
      counts: {
        total: activeCount + inactiveCount,
        active: activeCount,
        inactive: inactiveCount,
      },
    };
  }, [data]);

  return { dataset, counts, loading };
};
